const Gallery = () => {
    return (
        <div>
            Hello
        </div>
    )
}

export default Gallery;